import React, {
  createContext,
  useContext,
  type ReactNode,
} from "react";
import {
  useCompanyEmployeeSearch,
  type CompanyEmployeeSearchOption,
} from "@/hooks/useCompanyEmployeeSearch";

export type ShellEmployeeSearchState = {
  employees: ReturnType<typeof useCompanyEmployeeSearch>["employees"];
  options: CompanyEmployeeSearchOption[];
  filtered: ReturnType<typeof useCompanyEmployeeSearch>["filtered"];
  filteredOptions: CompanyEmployeeSearchOption[];
  loading: boolean;
  error: string | null;
  query: string;
  setQuery: ReturnType<typeof useCompanyEmployeeSearch>["setQuery"];
  submittedQuery: string;
  submitSearch: () => void;
  clearSearch: () => void;
  hasActiveQuery: boolean;
  resultCount: number;
  refresh: () => Promise<void>;
};

const ShellEmployeeSearchContext =
  createContext<ShellEmployeeSearchState | null>(null);

export function ShellEmployeeSearchProvider({
  companyId,
  children,
}: {
  companyId: string | null | undefined;
  children: ReactNode;
}) {
  const employeeSearch = useCompanyEmployeeSearch(companyId);

  return (
    <ShellEmployeeSearchContext.Provider value={employeeSearch}>
      {children}
    </ShellEmployeeSearchContext.Provider>
  );
}

export function useShellEmployeeSearch(): ShellEmployeeSearchState {
  const context = useContext(ShellEmployeeSearchContext);

  if (!context) {
    throw new Error(
      "useShellEmployeeSearch must be used within ShellEmployeeSearchProvider."
    );
  }

  return context;
}